import React, { } from 'react';
import { Input } from 'reactstrap';
import './index.scss';

const FilterDropdown = ({ options, handleVal, filter }) => {
    const handleOnChange = (value) => {
       
        handleVal(value);
    };
    return (
        <div className="status-dropdown">
            <Input type="select" name="select" onChange={($event) => { handleOnChange($event.target.value); }} className="form-select">
                {options && options.map((item, index) => {
                    return (<option key={index} selected={item.value==filter} value={item.value}>
                        {item.label}</option>);

                })}
            </Input>
        </div>
    )
}

export default FilterDropdown;